import React, { useState } from 'react';
import './PriceSection.css';

const PriceSection = () => {
  const [activeTab, setActiveTab] = useState('251');

  const pricingData = [
    {
      typology: 'Ground Floor + Basement',
      unitSize: '1323 + 1168',
      resalePrice: 'Call for price'
    },
    {
      typology: 'First Floor',
      unitSize: '1394',
      resalePrice: 'Call for price'
    },
    {
      typology: 'Second Floor + Terraces',
      unitSize: '1394 + 678',
      resalePrice: 'Call for price'
    }
  ];

  const plotSizes = [
    { id: '251', label: '251 SQ.YD.', data: pricingData },
    // You can add more plot sizes here if needed
    // { id: '300', label: '300 SQ.YD.', data: [...] }
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const getCurrentData = () => {
    const currentPlot = plotSizes.find(plot => plot.id === activeTab);
    return currentPlot ? currentPlot.data : pricingData;
  };

  return (
    <section className="price-section" id="price">
      <div className="container">
        <div className="price-layout">
          {/* Left Content */}
          <div className="price-content">
            <div className="price-header">
              <h2 className="price-title">
                Ansal Esencia <span className="highlight">Price List</span>
              </h2>
            </div>

            {/* Plot Size Tabs */}
            <div className="plot-tabs">
              {plotSizes.map((plot) => (
                <button
                  key={plot.id}
                  className={`plot-tab ${activeTab === plot.id ? 'active' : ''}`}
                  onClick={() => handleTabClick(plot.id)}
                >
                  {plot.label}
                </button>
              ))}
            </div>

            {/* Price Table */}
            <div className="price-table-container">
              <div className="table-header">
                <h3 className="table-title">Ready to Move</h3>
              </div>
              
              <div className="price-table-wrapper">
                <table className="price-table">
                  <thead>
                    <tr>
                      <th className="col-typology">Typology</th>
                      <th className="col-unit-size">Unit Size (Sq.Ft.)</th>
                      <th className="col-price">Resale Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getCurrentData().map((item, index) => (
                      <tr key={index} className="price-row">
                        <td className="typology">{item.typology}</td>
                        <td className="unit-size">{item.unitSize}</td>
                        <td className="resale-price">{item.resalePrice}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Additional Info */}
            <div className="price-notes">
              <div className="note-item">
                <h4>Important Notes:</h4>
                <ul>
                  <li>All prices are subject to change without prior notice</li>
                  <li>Registration and other charges are extra as applicable</li>
                  <li>For exact pricing and availability, please contact our sales team</li>
                  <li>Easy payment plans and home loan assistance available</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceSection;